module.exports = __webpack_public_path__ + "img/img9.be1b7b7f.svg";